import React, { useState } from 'react';
import { PaletteIcon } from 'lucide-react';
export function OrderBumpSection() {
  const [isChecked, setIsChecked] = useState(false);
  const colorimetriaPrice = 7000;
  const colorimetriaPriceOriginal = 26990;
  return <section className="w-full bg-[#0a0a0a] py-16 md:py-24 px-4" data-id="element-128">
      <div className="max-w-5xl mx-auto" data-id="element-129">
        <div className="bg-gradient-to-br from-[#1a1a1a] to-[#0a0a0a] border-4 border-[#c41e3a] rounded-2xl p-8 md:p-12 shadow-2xl" data-id="element-130">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center" data-id="element-131">
            {/* Imagen de colorimetría */}
            <div className="order-2 lg:order-1" data-id="element-132">
              <img src="https://cdn.magicpatterns.com/uploads/rh3A2iQ4JRbSVg1yJuF5Ev/colorimetria.png" alt="Ebook de Colorimetría aplicada a barbería" className="w-full rounded-lg shadow-2xl" data-id="element-133" />
            </div>

            {/* Contenido */}
            <div className="order-1 lg:order-2" data-id="element-134">
              <div className="flex items-start gap-4 mb-6" data-id="element-135">
                <PaletteIcon className="w-12 h-12 text-[#c41e3a] flex-shrink-0" aria-hidden="true" data-id="element-136" />
                <div data-id="element-137">
                  <h2 className="text-3xl md:text-4xl font-black text-white mb-4" data-id="element-138">
                    Sumá la formación en Colorimetría aplicada a barbería
                  </h2>
                  <p className="text-gray-300 text-lg leading-relaxed mb-6" data-id="element-139">
                    Podés agregar el ebook de Colorimetría Profesional como
                    complemento opcional. Incluye explicación clara de mezclas,
                    pigmentos, tiempos de exposición y resultados reales.
                  </p>
                  <p className="text-gray-200 font-semibold text-lg mb-8" data-id="element-140">
                    Ideal para elevar tu nivel técnico y ampliar tus servicios.
                  </p>
                </div>
              </div>

              <label className="flex items-start gap-4 cursor-pointer group bg-[#c41e3a]/10 p-6 rounded-lg border-2 border-[#c41e3a]/30 hover:border-[#c41e3a] transition-all" data-id="element-141">
                <input type="checkbox" checked={isChecked} onChange={e => setIsChecked(e.target.checked)} className="w-7 h-7 mt-1 rounded border-2 border-gray-400 text-[#c41e3a] focus:ring-2 focus:ring-[#c41e3a] focus:ring-offset-2 focus:ring-offset-[#1a1a1a] cursor-pointer flex-shrink-0" aria-label="Agregar formación en Colorimetría" data-id="element-142" />
                <div className="flex-1" data-id="element-143">
                  <span className="text-white text-xl font-bold group-hover:text-gray-200 transition-colors block mb-3" data-id="element-144">
                    🎨 Sí, quiero agregar Colorimetría
                  </span>
                  <div className="flex items-center gap-3" data-id="element-145">
                    <span className="text-gray-500 line-through text-xl font-semibold" data-id="element-146">
                      ${colorimetriaPriceOriginal.toLocaleString('es-AR')}
                    </span>
                    <span className="text-[#c41e3a] font-black text-3xl" data-id="element-147">
                      ${colorimetriaPrice.toLocaleString('es-AR')}
                    </span>
                  </div>
                </div>
              </label>
            </div>
          </div>
        </div>
      </div>
    </section>;
}